import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/photo-submissions';
export const fetchPhotoSubmissions = async (assignmentPublicId) => {
    const params = assignmentPublicId ? { assignmentPublicId } : undefined;
    return apiAxios.get(BASE, { params }).then((r) => r.data);
};
export const fetchPhotoSubmission = async (publicId) => apiAxios.get(`${BASE}/${publicId}`).then((r) => r.data);
export const postPhotoSubmission = async ({ data, file, }) => {
    const formData = new FormData();
    formData.append('assignmentPublicId', data.assignmentPublicId);
    formData.append('submittedVia', data.submittedVia);
    if (data.notes) {
        formData.append('notes', data.notes);
    }
    formData.append('imageFile', file, file.name);
    return apiAxios
        .post(BASE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then((r) => r.data);
};
export const deletePhotoSubmission = async (publicId) => apiAxios.delete(`${BASE}/${publicId}`).then((r) => r.data);
